import { render, staticRenderFns } from "./ShopifyImage.vue?vue&type=template&id=f4f4ce9a&"
import script from "./ShopifyImage.vue?vue&type=script&lang=js&"
export * from "./ShopifyImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports